import React,{useState,useEffect} from "react";
import { refreshNotifications } from "../utils/notifications";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { 
  MenuItem,
  Grid,
} from "@mui/material";
import FaxIcon from "@mui/icons-material/FaxOutlined";
import GroupsIcon from "@mui/icons-material/GroupsOutlined";
import ListParty from "./listParty";
import WhenText from "./whenText";
import { formatUsPhone, findContactByNumber, contactDisplayName } from "../utils/contacts";
import { withRouter } from "../utils/router";
import EnhancedTable from "./enhancedTable";
import {
  updateFaxes,
  deleteFax,
  forwardFaxes
} from "../utils/utils";
import {
  setNotifications,
  setNotificationsLoading,
} from "../store/features/notification/notificationSlice";
import { setCalls } from "../store/features/calls/callSlice";
import { setVoicemails } from "../store/features/voicemails/voicemailSlice";
import { setSmsConversations } from "../store/features/smsConversations/smsConversationsSlice";
import { setFaxes } from "../store/features/faxes/faxSlice";
import { setRecordings } from "../store/features/recordings/recordingSlice";
import { setError } from "../store/features/error/errorSlice";
import Forward from "./forward";
import ForwardViaEmail from "./forwardViaEmail";
import EditTitle from "./editTitle";
import { resetSession } from "../store/features/session/sessionSlice";

const mapDispatchToProps = {
  setError,
  setCalls,
  setVoicemails,
  setSmsConversations,
  setFaxes,
  setRecordings,
  setNotifications,
  setNotificationsLoading,
  resetSession,
};

const headCells = (groups) => {
  if (groups) {
    return {
      all: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      new: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      viewed: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      urgent: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      deleted: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
    };
  } else {
    return {
      all: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      new: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      viewed: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      urgent: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      deleted: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "title", numeric: true, disablePadding: false, label: "Document" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
    };
  }
}

const Faxes = (props) => {
  const {
    title,
    menu,
    menuItems,
    history,
    faxes,
    session,
    resetSession,
    setVoicemails,
    setSmsConversations,
    setFaxes,
    setRecordings,
    setNotifications,
    setNotificationsLoading,
    // handleDialClick,
    notifications,
    setValue,
    match,
    groups,
    personalPhonebook,
    setError
  } = props;

  let faxTab = match.params.faxTab;
  const [page,setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [forward, setForward] = useState(false);
  const [forwardItem, setForwardItem] = useState("")
  const [email, setEmail] = useState(false);
  const [attachment, setAttachment] = useState(null)
  const [titleChangeItem, setTitleChangeItem] = useState(null);
  const [titleModal, setTitleModal] = useState(false)
  const [faxFilterGroup, setFaxFilterGroup] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const defaultValues = {
    server: session.lastServer,
    token: session.token,
  };

  const createFaxGroupOptions = () => {
    // Use groupName as name if exists else groupNumber
    const faxGroups = [{key: "", value: "All groups"}];
    const map = new Map();
    for (const item of faxes) {
        if (item.group.toLowerCase() !== "yes")
          continue;
          
        if(!map.has(item.groupNumber)){
            map.set(item.groupNumber, true);    // set any value to Map
            faxGroups.push({
                key: item.groupNumber,
                value: item.groupName !== "" ? item.groupName : item.groupNumber
            });
        }
    }
    return faxGroups.map((item) => (
      <MenuItem key={item.key} value={item.key}>{item.value}</MenuItem>
    ));
  }

  const faxesFiltered = faxes.filter((item) => {
    if (!groups) {
      return item.group.toLowerCase() === "no";
    }

    if (faxFilterGroup.toLowerCase() === "")
      return item.group.toLowerCase() === "yes";

    return item.groupNumber === faxFilterGroup && item.group.toLowerCase() === "yes";
  });

  // Sender name: a personal contact whose number matches, when there is one.
  const senderName = (item) => contactDisplayName(findContactByNumber([personalPhonebook], item.from));

  const isNew = (item) => String(item.type || "").toLowerCase() === "new";
  const toneOf = (item) => {
    const type = String(item.type || "").toLowerCase();
    return type === "new" ? "brand" : type === "urgent" ? "urgent" : "neutral";
  };

  // Group fax lines: the group, with who sent the fax underneath.
  const renderGroupNameCell = (item) => {
    const groupNumber = String(formatUsPhone(item.groupNumber) || "");
    const from = senderName(item) || String(formatUsPhone(item.from) || "");
    return (
      <ListParty
        icon={<GroupsIcon />}
        tone={toneOf(item)}
        title={item.groupName || groupNumber || "Group"}
        detail={[
          from !== "" ? `From ${from}` : "",
          item.groupName && groupNumber !== "" ? `Line ${groupNumber}` : "",
        ].filter(Boolean).join(" · ")}
        isNew={isNew(item)}
        wrap
      />
    );
  };

  // Who sent the fax, with the number on a second line when a name is known.
  const renderFromCell = (item) => {
    const name = senderName(item);
    const number = String(formatUsPhone(item.from) || "");
    return (
      <ListParty
        icon={<FaxIcon />}
        tone={toneOf(item)}
        title={name !== "" ? name : (number || "Unknown sender")}
        detail={name !== "" ? number : ""}
        isNew={isNew(item)}
      />
    );
  };

  const faxRowItem = (item) => {
    let obj = {
      from: renderFromCell(item),
      // Shown without the file extension; a fax without a title reads "Fax".
      title: String(item.title || "").replace(/\.(pdf|tiff?)$/i, "").trim() || "Fax",
      status: item.type,
      received: <WhenText dateTime={item.dateTime} />,
      object: item,
    };

    if (item.type === "deleted") {
      obj.actions = [{ type: "delete" }];
    } else {
      obj.actions = [
        { type: "delete" },
        { type: "viewTif" },
        { type: "viewPdf" },
        { type: "email" },
        { type: "forward" },
        { type: "editTitle" },
      ];
    }

    if (groups) {
      // The group cell also says who sent it, so there is no From column.
      const { from, ...rest } = obj;
      obj = { groupName: renderGroupNameCell(item), ...rest };
    }

    return obj; 
  }

  // Search: a sender's name, the document, a group, or a number typed any way.
  const term = searchTerm.trim().toLowerCase();
  const termDigits = /^[\d\s()+.-]+$/.test(term) ? term.replace(/\D/g, "") : "";
  const matchesSearch = (item) => {
    if (term.length < 2) return true;
    if (senderName(item).toLowerCase().includes(term)) return true;
    if (String(item.title || "").toLowerCase().includes(term)) return true;
    if (groups && String(item.groupName || "").toLowerCase().includes(term)) return true;
    const number = String(item.from || "");
    if (number.toLowerCase().includes(term)) return true;
    if (termDigits.length < 2) return false;
    const digits = number.replace(/\D/g, "");
    return digits.includes(termDigits) ||
      (termDigits.length > 2 && termDigits[0] === "1" && digits.includes(termDigits.slice(1)));
  };

  // Which faxes a tab shows.
  const inTab = (item, tab) => {
    const type = String(item.type || "").toLowerCase();
    switch (tab) {
      case "new":
        return type === "new";
      case "viewed":
        return type === "old";
      case "urgent":
        return type === "urgent";
      case "deleted":
        return type === "deleted";
      case "all":
        return item.type !== "deleted";
      default:
        return false;
    }
  };

  const generateRows = () => {
    return faxesFiltered
      .filter((item) => inTab(item, faxTab) && matchesSearch(item))
      .map((item) => faxRowItem(item));
  }

  // The New and Urgent tabs say how many faxes wait in them.
  const menuWithCounts = (menuItems || []).map((item) => (
    item.linkId === "new" || item.linkId === "urgent"
      ? { ...item, count: faxesFiltered.filter((fax) => inTab(fax, item.linkId)).length }
      : item
  ));

  const refetchNotifications = () => refreshNotifications({
    values: defaultValues,
    setters: { setCalls, setFaxes, setRecordings, setVoicemails, setSmsConversations },
    setNotifications,
    setNotificationsLoading,
    onUnauthorized: () => {
      resetSession();
      history.push('/login');
    },
  });

  const clearCurrentNotifications = () =>{
    let values = defaultValues;

    values.fax = faxes
      .filter(
        (fax) => 
        (fax.viewed!=="yes" && fax.type.toLowerCase()===faxTab.toLowerCase()) ||
        (fax.viewed!=="yes" && faxTab.toLowerCase()==="viewed" && fax.type.toLowerCase()==="old")
      )
      .map((fax) => {
        return {
          fid: fax.fid,
          viewed: "yes",
          type: fax.type,
          group: fax.group,
          title: fax.title
        };
      })
    try {
      updateFaxes(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    clearCurrentNotifications();
    // eslint-disable-next-line
  }, [faxTab, title]);

  const handleStatusChange = async (type,item) => {
    let values = defaultValues;

    values.fax = [
      {
        fid: item.fid,
        title: item.title,
        viewed: type.toLowerCase()==="deleted" ? "yes" : item.viewed,
        group: item.group,
        type: type.toLowerCase()==="viewed" ? "old" : type.toLowerCase()
      }
    ];

    try {
      await updateFaxes(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  const handleDelete = (items) => {
    let values = defaultValues;
    console.log(items)
    values.fax = items.map(item=>
      item.hasOwnProperty("object")
        ? {
            fid: item.object.fid,
            title: item.object.title,
            viewed: "yes",
            group: item.object.group,
            type: "deleted",
          }
        : {
            fid: item.fid,
            title: item.title,
            viewed: "yes",
            group: item.group,
            type: "deleted",
          }
    );
    console.log("values", values);
    try {
      updateFaxes(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  const handleDeleteForever = (item) => {
    let values = defaultValues;
    values.id = item.fid
    values.group = item.group
    console.log("delete", values);
    try {
      deleteFax(values);
      setError({
        visible: true,
        type: "success",
        message: "Successfully deleted Item",
      });
      refetchNotifications();
    } catch (error) {
      setError({
        visible: true,
        type: "error",
        message: error,
      });
      console.error(error);
    }
  }

  return (
    <Grid container>
      <Grid size={12}>
        <ForwardViaEmail
          open={email}
          setOpen={setEmail}
          file={attachment}
          type="Fax"
          defaultValues={defaultValues}
        />
        <Forward
          open={forward}
          setOpen={setForward}
          value={forwardItem}
          type="Fax"
          forwardFunction={forwardFaxes}
          idKey="fid"
          groupKey="group"
          defaultValues={defaultValues}
        />
        {titleModal && (
          <EditTitle
            open={titleModal}
            setOpen={setTitleModal}
            value={titleChangeItem}
            type="Fax"
            defaultValues={defaultValues}
            setTitleChangeItem={setTitleChangeItem}
            reloadNotifications={refetchNotifications}
          />
        )}
        <EnhancedTable
          setError={setError}
          type="fax"
          headerData={headCells(groups)}
          rowData={generateRows()}
          dense={false}
          hasActions={true}
          selectable={true}
          menu={menu ? menuWithCounts : false}
          searchFunc={(value) => { setSearchTerm(value); setPage(0); }}
          title={title}
          tab={faxTab}
          history={history}
          hasClear={false}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          // handleDialClick={handleDialClick}
          setValue={setValue}
          setForwardItem={setForwardItem}
          setForward={setForward}
          loading={notifications.loading}
          statusChangeFunction={handleStatusChange}
          handleDelete={handleDelete}
          handleDeleteForever={handleDeleteForever}
          setAttachment={setAttachment}
          setSendEmail={setEmail}
          setTitleChangeItem={setTitleChangeItem}
          setEditTitle={setTitleModal}
          useGroupFilter={groups}
          createGroupOptions={createFaxGroupOptions}
          filterGroup={faxFilterGroup}
          setFilterGroup={setFaxFilterGroup}
          refreshDataOnSameTab={clearCurrentNotifications}
        />
      </Grid>
    </Grid>
  );
};

Faxes.propTypes = {
  title: PropTypes.string.isRequired,
  menu: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkId: PropTypes.string,
    })
  ),
  tab: PropTypes.string.isRequired,
  // handleDialClick: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  groups: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    faxes: state.faxes,
    notifications: state.notifications,
    personalPhonebook: state.personalPhonebook,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Faxes));